<template lang="pug">
  .color-solve-selector.xs-f-small.max-at-tweak(v-if="productColorSolveSelector")
    .types-wrap.selector-wrap.ui-color-3-bg
      p.selector-title.bold.xs-f-small.max-at-tweak
        span.selector-title-number 1.
        span(v-html="cmsData.typeTitle")

      .swatches
        horizontal-selector(:selected-index="selectedTypeIndex"  :drag-mode="true")
          .swatch-outer-wrap(v-for="(swatch, index) in types"  :class="{'best-match': bestMatchColorSolveSelector && bestMatchColorSolveSelector.type == swatch.key}")
            span.best-match-text.color-white.xs-f-xxsmall.max-at-tweak(v-if="bestMatchColorSolveSelector && bestMatchColorSolveSelector.type == swatch.key") Best Match
            PdpSwatchButton.swatch-wrap(:disabled="swatchDisabled(swatch.key, selectedFormula, selectedColorShot)"  :selected="productColorSolveSelector.type == swatch.key"  :label="swatch.title"  :img-url="swatch.image.url" @click="selectProduct(swatch.key, selectedFormula, selectedColorShot)")

    .formulas-wrap.selector-wrap
      p.selector-title.bold.xs-f-small.max-at-tweak
        span.selector-title-number 2.
        span(v-html="cmsData.formulaTitle")

      .advisor-cta-wrap
        p.text-color-4.xs-f-xsmall.max-at-tweak(v-if="bestMatchColorSolveSelector") The following recommendation is based on your quiz results:
        p.advisor-cta.text-color-4.xs-f-xsmall.max-at-tweak(v-else)
          a.underline.semi-bold(href="/color-advisor?next=/product/colorsolve") Take our quiz
          |  for personalized recommendations

      .swatches
        horizontal-selector(:selected-index="selectedFormulaIndex"  :drag-mode="true")
          .swatch-outer-wrap(v-for="(swatch, index) in formulas"  :class="{'best-match': bestMatchColorSolveSelector && bestMatchColorSolveSelector.formula == swatch.key}")
            span.best-match-text.color-white.xs-f-xxsmall.max-at-tweak(v-if="bestMatchColorSolveSelector && bestMatchColorSolveSelector.formula == swatch.key") Best Match
            PdpSwatchButton.swatch-wrap(:disabled="swatchDisabled(selectedType, swatch.key, selectedColorShot)"  :selected="productColorSolveSelector.formula == swatch.key"  :label="swatch.title"  :img-url="swatch.image.url" @click="selectProduct(selectedType, swatch.key, selectedColorShot)")

    .color-shots-wrap.selector-wrap.ui-color-3-bg(:class="{'selector-disabled': colorShotsDisabled}")
      p.selector-title.bold.xs-f-small.max-at-tweak
        span.selector-title-number 3.
        span(v-html="cmsData.colorShotTitle")

      .advisor-cta-wrap
        p.text-color-4.xs-f-xsmall.max-at-tweak(v-if="bestMatchColorSolveSelector") The following recommendation is based on your quiz results:
        p.advisor-cta.text-color-4.xs-f-xsmall.max-at-tweak(v-else)
          a.underline.semi-bold(href="/color-advisor?next=/product/colorsolve") Take our quiz
          |  for personalized recommendations

      .swatches
        horizontal-selector(:selected-index="selectedColorShotIndex"  :drag-mode="true")
          .swatch-outer-wrap(v-for="(swatch, index) in colorShots"  :class="{'best-match': bestMatchColorSolveSelector && bestMatchColorSolveSelector.colorshot == swatch.key}")
            span.best-match-text.color-white.xs-f-xxsmall.max-at-tweak(v-if="bestMatchColorSolveSelector && bestMatchColorSolveSelector.colorshot == swatch.key") Best Match
            PdpSwatchButton.swatch-wrap(:disabled="colorshotDisabled(selectedType, selectedFormula, swatch.key)"  :selected="productColorSolveSelector.colorshot == swatch.key"  :label="swatch.title"  :img-url="swatch.image.url" @click="selectProduct(selectedType, selectedFormula, swatch.key)")

</template>

<script>
  import vueProductSvc from '@services/vueProductSvc';
  import { mapState } from 'vuex';
  import PdpSwatchButton from "@components/PDP/PdpSwatchButton";
  import HorizontalSelector from "@components/horizontalSelector";

  export default {
    name: "ColorSolveSelector",

    components: {
      PdpSwatchButton,
      HorizontalSelector
    },

    inject: ['getObjProperty'],

    data() {
      return {
        colorSolveProductMap: null,
        colorSolveRecommendation: null,
      };
    },

    computed: {
      ...mapState('pdp', ['product']),
      ...mapState('cms', ['cmsSettings']),
      ...mapState('customer', ['cdata', 'refreshingCdata']),

      breakpoint() {
        return this.getObjProperty(this, '$root.windowData.breakpoint');
      },

      isMobile() {
        return this.breakpoint == 'mobile' || this.breakpoint == 'tablet';
      },

      colorSolveRecommendationId() {
        if (this.refreshingCdata) {
          return null;
        }

        if (this.cdata && this.cdata.allRecommendations && this.cdata.allRecommendations.colorsolve && this.cdata.allRecommendations.colorsolve.length) {
          return this.cdata.allRecommendations.colorsolve[0];
        }

        return null;
      },

      productColorSolveSelector() {
        return this.getColorSolveSelector(this.product);
      },

      bestMatchColorSolveSelector() {
        return this.getColorSolveSelector(this.colorSolveRecommendation);
      },

      selectedType() {
        return this.productColorSolveSelector.type;
      },

      selectedTypeIndex() {
        return this.types.findIndex(type => {
          return type.key == this.selectedType;
        });
      },

      selectedFormula() {
        return this.productColorSolveSelector.formula;
      },

      selectedFormulaIndex() {
        return this.formulas.findIndex(formula => {
          return formula.key == this.selectedFormula;
        });
      },

      selectedColorShot() {
        return this.productColorSolveSelector.colorshot;
      },

      selectedColorShotIndex() {
        return this.colorShots.findIndex(colorShot => {
          return colorShot.key == this.selectedColorShot;
        });
      },

      cmsData() {
        if (this.cmsSettings && this.cmsSettings.colorSolveSelector) {
          return this.cmsSettings.colorSolveSelector;
        }
        return null;
      },

      types() {
        if (this.cmsData && this.cmsData.type) {
          return this.cmsData.type;
        }
        return null;
      },

      formulas() {
        if (this.cmsData && this.cmsData.formula) {
          return this.cmsData.formula;
        }
        return null;
      },

      colorShots() {
        if (this.cmsData && this.cmsData.colorshot) {
          return this.cmsData.colorshot;
        }
        return null;
      },

      colorShotsDisabled() {
        if (!this.colorShots) {
          return true;
        }
        let numColorShotsEnabled = 0;

        this.colorShots.forEach(colorshot => {
          if (!this.colorshotDisabled(this.selectedType, this.selectedFormula, colorshot.key)) {
            numColorShotsEnabled += 1;
          }
        });

        return numColorShotsEnabled <= 1;
      }
    },

    watch: {
      colorSolveRecommendationId(value) {
        if (value) {
          vueProductSvc.getProductById({ id: value }).then(res => {
            this.colorSolveRecommendation = res.data;
          });
        }
      }
    },

    methods: {
      getColorSolveType(product) {
        if (!product.hierarchy || product.hierarchy.length == 0) {
          return null;
        }

        if (product.hierarchy.some(h => h.name == 'ColorSolve S+C+Shot') || product.hierarchy.some(h => h.name == 'ColorSolve S+C')) {
          return 'shampooconditioner';
        }

        if (product.hierarchy.some(h => h.name == 'ColorSolve Shampoo + Shot') || product.hierarchy.some(h => h.name == 'ColorSolve Shampoo')) {
          return 'shampoo';
        }

        if (product.hierarchy.some(h => h.name == 'ColorSolve Conditioner')) {
          return 'conditioner';
        }

        return null;
      },

      getColorSolveSelector(product) {
        if (product && this.getColorSolveType(product) && product.pimMatrixFormula) {
          return {
            type: this.getColorSolveType(product),
            formula: product.pimMatrixFormula,
            colorshot: product.pimMatrixColorShot || 'none'
          };
        }

        return null;
      },

      selectProduct(type, formula, colorshot) {
        let productData = this.getObjProperty(this.colorSolveProductMap, `${type}.${formula}.${colorshot}`);
        
        if (!productData) {
          productData = this.getObjProperty(this.colorSolveProductMap, `${type}.${formula}.none`);
        }

        if (productData && productData.url_key != this.product.url_key) {
          this.$router.push('/product/' + productData.url_key);
        }
      },

      swatchDisabled(type, formula, colorshot) {
        return !this.getObjProperty(this.colorSolveProductMap, `${type}.${formula}.${colorshot}`) && !this.getObjProperty(this.colorSolveProductMap, `${type}.${formula}.none`);
      },

      colorshotDisabled(type, formula, colorshot) {
        return !this.getObjProperty(this.colorSolveProductMap, `${type}.${formula}.${colorshot}`);
      }
    },

    mounted() {
      if (this.product.product_type == 'colorsolve') {
        vueProductSvc.getColorSolveProductMap().then(res => {
          this.colorSolveProductMap = res.data;
        });
      }
    }
  };
</script>

<style scoped lang="stylus">
  .color-solve-selector
    .selector-wrap
      padding 0.75em 3%
      
      .swatches
        overflow hidden
      
      .selector-title
        position relative
        padding-bottom 0.5em
        padding-left 1em
        
        .selector-title-number
          position absolute
          left 0
          top 0
          
      .advisor-cta-wrap
        padding-left 1em
        padding-bottom 0.75em
        padding-right 6em
        
    .swatch-outer-wrap
      position relative
      display inline-block
      vertical-align top
      border 1px solid transparent
      padding 1.75em 0.25em 0.5em
      text-align center
      
      &.best-match
        border-color ui-color-7
      
      .best-match-text
        position absolute
        top 0
        left 0
        right 0
        background ui-color-7
        text-align center
        padding 0.25em
        padding-top 0.2em
        
    .swatch-wrap
      position relative
      display inline-block
      vertical-align top
      width 5em
      text-align center
      white-space normal
      padding 0
      
    .color-shots-wrap
      &.selector-disabled
        *
          opacity 0.5
      
</style>
